import { useCallback } from 'react'

import { useOnErrorSnackbar } from 'hooks'
import { ApiErrorBase } from 'api/core/ApiErrorBase'

export function useOnApiError(onError?: Function) {
  const onErrorSnackbar = useOnErrorSnackbar()
  return useCallback(
    (apiError: ApiErrorBase, ...args: any) => {
      onError?.(apiError, ...args)
      return onErrorSnackbar(
        apiError,
        apiError.statusCode ? `http status: ${apiError.statusCode}` : undefined,
      )
    },
    [onError, onErrorSnackbar],
  )
}
